import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Main from "./layout/Main";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn } = useContext(AuthContext);

  // if (isLoggedIn) {
  //   return <Navigate to="/login" replace />;
  // }

  return <Main>{children}</Main>;
};

export default PrivateRoute;
